export default __webpack_public_path__ + "_/shared_modules/sprites/dist/sprite-k12-banner-family-8500aceddcb46cacff132604e03c5bb8.png";